import React from 'react';
import { func, bool, string } from 'prop-types';

// Import  styles
import { ButtonStyled } from './styles';

const PaymentOptionButton = ({
	onClick = () => {},
	isDisabled = false,
	buttonText = '',
	labelledBy
}) => (
	<ButtonStyled
		aria-labelledby={labelledBy}
		modifiers="default"
		onClick={onClick}
		disabled={isDisabled}
	>
		{buttonText}
	</ButtonStyled>
);

PaymentOptionButton.propTypes = {
	onClick: func.isRequired,
	isDisabled: bool,
	buttonText: string.isRequired,
	labelledBy: string.isRequired
};

export default PaymentOptionButton;
